// extracted by mini-css-extract-plugin
module.exports = {"pageWrapper":"FAQ_pageWrapper__1QEst","pageContainer":"FAQ_pageContainer__NOMzb","pageSection":"FAQ_pageSection__1HMXX"};